<template>
  <div>
    <strong>Sync status for order {{ orderID }}</strong>
    <div v-if="syncs.results && syncs.results.length">
      <table class="table is-bordered striped" align="center">
        <thead>
            <tr>
                <th>Event ID</th>
                <th>Event Type</th>
                <th>Sync Time</th>
                <th>Event Received At</th>
                <th>Destination</th>
                <th>Status</th>
                <th>Hold Status</th>
                <th>Fulfillment Status</th>
                <th>Destination ID</th>
                <th>Manually Sync</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="event in syncs.results" v-bind:class="{ failed: sync_failed(event) }">
                <td>{{event.id}}</td>
                <td>{{event.event_type}}</td>
                <td>{{ to_local(event.updated_at) }}</td>
                <td>{{ to_local(event.event_received_at) }}</td>
                <td>{{event.destination}}</td>
                <td>{{event.status}}</td>
                <td>{{event.hold_status}}</td>
                <td>{{event.fulfillment_status}}</td>
                <td>{{event.destination_id}}</td>
                <td><button v-if="sync_failed(event) && has_permissions(['manual_sync_event'])" type="is-warning" class="button flex-pulled-right" @click="confirm_sync(event)">Mark synced</button></td>
            </tr>
        </tbody>
          <Pagination ref="syncs_paginator" :dest_obj="this" :dest_name="'syncs'" :endpoint="requestUrl"/>
      </table>
    </div>
    <div v-else>
      No sync event found...
    </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import moment from 'moment'
    import Pagination from './Pagination'
    import auth from '../auth'

    export default {
      name: 'OrderStatusSyncs',
      computed: {
        requestUrl () {
          return `${this.$constants.EVENT_SYNC_URL}/${this.$route.params.order_id}`
        },
        orderID () {
          return this.$route.params.order_id
        }
      },
      data () {
        return {
          syncs: {
            prev_page: null,
            next_page: null,
            results: null
          }
        }
      },
      components: {
        Pagination
      },
      created () {
        this.fetchData()
      },
      methods: {
        fetchData () {
          axios.get(this.requestUrl)
            .then(response => {
              this.syncs = response.data.items
            })
            .catch(error => {
              this.syncs = {
                prev_page: null,
                next_page: null,
                results: null
              }
              console.log(error.msg)
            })
        },
        sync_failed (event) {
          return event.status === 'failed' || event.hold_status === 'failed' || event.fulfillment_status === 'failed'
        },

        event_failed (event) {
          return event.result === 'failed' || event.result === 'failure'
        },

        is_long (msg) {
          if (!msg) {
            return false
          }

          return msg.length > 25
        },

        xml_tag (msg) {
          const pattern = /<.*>/g
          const parts = pattern.exec(msg)

          if (parts) {
            return '(XML)'
          }

          return ''
        },

        show_msg_modal (msg) {
          this.$root.open_message_modal(msg, true)
        },

        to_local (utcDT) {
          return moment(utcDT).format('DD/MM/YYYY HH:mm:ss')
        },
        has_permissions (permissions) {
          return permissions.every(auth.hasPermission, auth.getPermissions())
        },
        confirm_sync (event) {
          this.$buefy.dialog.confirm({
            message: 'Manually create successful sync event for order ' + event.order_id + '?',
            onConfirm: () => this.mark_as_synced(event)
          })
        },
        mark_as_synced (event) {
          const eventData = {
            order_id: event.order_id,
            shop_url: event.shop_url,
            destination: event.destination,
            order_number: event.order_number
          }
          axios.post(this.$constants.MANUAL_SYNC_EVENT_URL, eventData)
            .then((response) => {
              this.$buefy.toast.open({
                message: 'Successful Sync Event created',
                type: 'is-info'
              })
            }).catch((error) => {
              this.loading = false
              this.$buefy.toast.open({
                message: error.data,
                type: 'is-danger'
              })
            }).finally(() => {
              this.fetchData()
            })
        }
      }
    }

</script>

<style scoped>

</style>
